import { TaskInformation } from '../../components';
import { useQuestionReviewTaskDetails } from '../../providers';

export default function QuestionReviewTaskInformation() {
  const { taskDetails } = useQuestionReviewTaskDetails();

  const assigneeNames = taskDetails.subtasks
    .map((subtask) => `${subtask.assignee.firstname} ${subtask.assignee.lastname}`)
    .join(', ');

  const taskInformationContent = [
    { label: 'Task Name', value: taskDetails.name ?? '' },
    { label: 'Owner', value: `${taskDetails.owner.firstname} ${taskDetails.owner.lastname}` },
    { label: 'Reviewer', value: assigneeNames },
  ];

  return <TaskInformation content={taskInformationContent} />;
}
